var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.875,
    height: 98.438,
    viewBox: "0 0 96.875 98.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.125,10.566a48.432,48.432,0,1,1-56.289.02,4.7,4.7,0,0,1,6.836,1.5l3.086,5.488a4.686,4.686,0,0,1-1.289,6.055,32.81,32.81,0,1,0,39.043-.02,4.659,4.659,0,0,1-1.27-6.035l3.086-5.488A4.682,4.682,0,0,1,78.125,10.566Zm-20.312,41V4.688A4.676,4.676,0,0,0,53.125,0h-6.25a4.676,4.676,0,0,0-4.687,4.688V51.563a4.676,4.676,0,0,0,4.688,4.688h6.25A4.676,4.676,0,0,0,57.813,51.563Z",
    transform: "translate(-1.562)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a48cfa81d6c9a93b67f2a40ab16ce835.svg";
export { ForwardRef as ReactComponent };